export default "__VITE_ASSET__c0f13140__"